import type {FC} from 'react';
import {PostRegisterEntryPromptModal} from '../../features/postRegisterEntryPrompt/components/Presenter/PostRegisterEntryPromptModal';
import {usePostRegisterEntryPrompt} from '../../features/postRegisterEntryPrompt/usecase/usePostRegisterEntryPrompt';
import {UnfinishedEntryPromptModal} from '../../features/unfinishedEntryPrompt/components/Presenter/UnfinishedEntryPromptModal';
import {useUnfinishedEntryPrompt} from '../../features/unfinishedEntryPrompt/usecase/useUnfinishedEntryPrompt';
import {UniversityEmailVerifyPromptModal} from '../../features/universityEmailVerifyPrompt/components/Presenter/UniversityEmailVerifyPromptModal';
import {useUniversityEmailVerifyPrompt} from '../../features/universityEmailVerifyPrompt/usecase/useUniversityEmailVerifyPrompt';
import {ScoutNotificationModal} from './ScoutNotificationModal';

/**
 * 二重表示を避けるため表示状態を橋渡しする。
 * 優先順位はエントリー促進 > エントリー未完了 > 大学メール認証 > スカウト通知。
 */
export const RegisterPrompts: FC = () => {
  const postRegisterEntryPrompt = usePostRegisterEntryPrompt();
  const unfinishedEntryPrompt = useUnfinishedEntryPrompt({
    isHigherPriorityPromptOpened: postRegisterEntryPrompt.opened,
    isHigherPriorityPromptDeciding: postRegisterEntryPrompt.isDeciding,
  });
  // 大学メール認証より上位のポップアップはまとめて渡す
  const universityEmailVerifyPrompt = useUniversityEmailVerifyPrompt({
    isPostRegisterEntryPromptOpened:
      postRegisterEntryPrompt.opened || unfinishedEntryPrompt.opened,
    isPostRegisterEntryPromptDeciding:
      postRegisterEntryPrompt.isDeciding || unfinishedEntryPrompt.isDeciding,
  });

  return (
    <>
      <PostRegisterEntryPromptModal
        opened={postRegisterEntryPrompt.opened}
        onClose={postRegisterEntryPrompt.close}
        recruitments={postRegisterEntryPrompt.recruitments}
        basedOnWishIndustries={postRegisterEntryPrompt.basedOnWishIndustries}
      />
      <UnfinishedEntryPromptModal
        // 表示のたびに作り直して表示計測を毎回送る
        key={unfinishedEntryPrompt.showCount}
        opened={unfinishedEntryPrompt.opened}
        onClose={unfinishedEntryPrompt.close}
        recruitments={unfinishedEntryPrompt.recruitments}
      />
      <UniversityEmailVerifyPromptModal
        opened={universityEmailVerifyPrompt.opened}
        onClose={universityEmailVerifyPrompt.close}
      />
      <ScoutNotificationModal
        suppressed={
          postRegisterEntryPrompt.opened ||
          unfinishedEntryPrompt.opened ||
          universityEmailVerifyPrompt.opened
        }
      />
    </>
  );
};
